module.exports = __webpack_public_path__ + "static/media/productTypeHouse.b484ade9.svg";